import { Button, Col, Layout, Menu } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import Header from '../Home/Header'
import {  Card, CardBody, CardHeader, Container, Row } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux';
import { getSchools } from '../actions/school';
import { getAttendances } from '../actions/attendance';
import { getReports, getReport } from '../actions/report';
import { getStudentreports } from '../actions/studentreport';
import { useParams } from 'react-router-dom';
import Report from './ReportDetails';
import axios from 'axios';
import { axiosConfig, SERVER_PATH } from '../actions/common';


const { Content } = Layout;

export default function Menus(props) {

  const {index2:reportid} = useParams()
  const [arrreports, setarrreports] = useState({})
  const dispatch = useDispatch()
  const userSelector = useSelector(state=>state.userReducer)
  const {user, mid, schoolId} = userSelector
  const repid = reportid 
  const reportSelector = useSelector(state=>state.reportReducer)
  const {reports, schools, sessions, terms, claszs:claszs1} = reportSelector

  const [cbts, setcbts] = useState([])
  const [errno, seterrno] = useState('')


 const load = () => {
    if(mid > 0){
      let params = {
        data:JSON.stringify(
        {
           'studentid': mid
        }),
        cat:'selectstudentcbt',
        table:'students',
        narration:'get school'
      }
      axios.get(SERVER_PATH, {params}, axiosConfig)
      .then(res=>{setcbts(res.data); seterrno('')})
      .catch(err=>seterrno(err))
      dispatch(getSchools(params))
    }
  }

  useEffect(() => load(), [mid])
  
  

  return (
    <Layout className="site-layout" style={{minHeight:'800px'}}>
        {/* <Headers /> */}
     <Content className="site-layout text-left" style={{ margin: '0 0rem', marginTop: 0 }}>
       <Row style={{minHeight:'800px'}}>
        <Col>
        <Card>
                    <CardHeader>
                        <h5>Test ({cbts.length || 0})</h5>
                    </CardHeader>
                   <CardBody className='table-responsive'>      
                        <table dark width="100%" style={{fontFamily:'Quicksand', fontSize:"min(max(12px, 2vw), 17px)"}} border="solid 2px #000000">
                            <thead>
                            <tr className="text-center">
                                <th>SN</th>
                                <th>SUBJECT</th>
                                <th>CLASS</th>
                                <th>NOQ.</th>
                                <th>TIME</th>
                                <th>SCORE</th>
                            </tr>
                            </thead>
                            <tbody>
                                { Array.isArray(cbts) ?
                                    cbts.map((p, i)=>{
                                        let {id, subjectname, cbtname, cbtexamid, noq, status, score, duration } = p
                                        return <tr key={id}>
                                            <td className='text-center'>{i + 1}</td>
                                            <td>
                                              {subjectname}
                                              </td>
                                            <td>
                                              <a href={`https://www.skoolq.com/ems/#/studenttest/${mid}/${status}/${cbtexamid}/${id}`} target='_blank'>{cbtname}</a></td>
                                            <td className='text-center'>{noq}</td>
                                            <td className='text-center'>{duration}</td>
                                            <td>
                                                <Button block color="success" >
                                                    {Number(score * noq).toFixed(0)}
                                                </Button>
                                            </td>
                                        </tr>
                                    })
                                :null
                                    
                                }
                            </tbody>
                        </table>
                    </CardBody>

                </Card>
        </Col>
       </Row>
    </Content>
    </Layout>
  )
}
